import { DirectiveOptions } from 'vue';

const triggerPopover: DirectiveOptions = {
    bind(el) {
        // Bootstrap 3.4+ sanitizes HTML by default and strips table markup used in tiered pricing popovers.
        $(el).popover({ sanitize: false });
    },
    unbind(el) {
        $(el).popover('destroy');
    }
};

export default triggerPopover;